import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const viewSettingsStyleId = 'wb-v2-view-settings-theme';

export const viewSettingsBridgeStyles = {
  'view-settings': {
    '--local-view-settings-panel-bg': tokens.color.background.primary,
    '--local-view-settings-panel-border': tokens.color.border.secondary,
    '--local-view-settings-panel-shadow': tokens.shadow.lg,
    '--local-view-settings-header-gap': tokens.spacing.sm,
    '--local-view-settings-header-icon-color': tokens.color.text.secondary,
    '--local-view-settings-title-font-family': tokens.font.family.body,
    '--local-view-settings-title-font-size': tokens.font.size.textSm,
    '--local-view-settings-title-font-weight': tokens.font.weight.semibold,
    '--local-view-settings-title-line-height': tokens.lineHeight.textSm,
    '--local-view-settings-title-color': tokens.color.text.primary,
    '--local-view-settings-edit-color': tokens.color.text.tertiary,
    '--local-view-settings-edit-radius': tokens.radius.xs,
    '--local-view-settings-edit-hover-bg': tokens.color.background.secondary,
    '--local-view-settings-edit-hover-color': tokens.color.text.primary,
    '--local-view-settings-item-stack-gap': tokens.spacing.xxs,
    '--local-view-settings-item-hover-radius': tokens.radius.xs,
    '--local-view-settings-placeholder-font-family': tokens.font.family.body,
    '--local-view-settings-placeholder-font-size': tokens.font.size.textSm,
    '--local-view-settings-placeholder-font-weight': tokens.font.weight.regular,
    '--local-view-settings-placeholder-line-height': tokens.lineHeight.textSm,
    '--local-view-settings-placeholder-color': tokens.color.text.tertiary,
  },
};
